module.exports = __webpack_public_path__ + "img/target_icon01.77dfab17.png";